module.exports = __webpack_public_path__ + "static/videoposter-85216a7cbfad9ec6432e198b487c98c3.jpg";